// `__CONNECT_RN_VERSION__` is replaced at build time with the package version
// via esbuild `define` (see build.js). The `typeof` guard keeps this safe under
// vitest / tsc, where the define isn't applied and the identifier is undefined.
declare const __CONNECT_RN_VERSION__: string

export const CONNECT_RN_VERSION: string =
  typeof __CONNECT_RN_VERSION__ === 'string'
    ? __CONNECT_RN_VERSION__
    : '0.0.0-dev'
